/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SurveyRequest = {
    surveyVendorId?: string;
    surveyJobProfileId?: string;
    code?: string;
    name?: string;
    version?: string | null;
    public?: boolean;
    effectiveDate?: string;
    status?: SurveyRequest.status;
    files?: Array<Record<string, any>>;
};

export namespace SurveyRequest {

    export enum status {
        REPORT = 'report',
        PARTICIPATION = 'participation',
    }


}

